<template>
    <div>
      <el-input class="search-el" size="small" v-model="query.name" placeholder="标题" clearable @clear="getList()" @change="getList()"></el-input>
      <el-button type="primary" size="small" @click="getList()" :loading="loading">
        查询
      </el-button>
      <el-button type="primary" size="small" @click="createInfo()" >
        添加分类
      </el-button>
      <el-row>
        <el-table v-loading="loading" :data="list" border size="mini" :stripe="true" style="width: 100%; margin: 20px 0">
            <el-table-column prop="id" label="id" align="center" width="40"></el-table-column>
            <el-table-column prop="name" label="分类名称" align="center"></el-table-column>
            <el-table-column label="类型" align="center" width="70">
                <template slot-scope="{row}">
                    <div>{{ row.type && row.type == 1 ? '遇见视频' : row.type && row.type == 2 ? '首页视频' : '-' }}</div>
                </template>
            </el-table-column>
            <!-- <el-table-column label="封面图" align="center">
                <template slot-scope="{row}">
                    <img :src="row.img_url" style="width:40px" alt="">
                </template>
            </el-table-column> -->
            <!-- <el-table-column prop="title" label="标题" align="center"></el-table-column> -->
            <el-table-column prop="sort" label="排序" align="center"></el-table-column>
            <!-- <el-table-column prop="moment_amount" label="动态数量" align="center"></el-table-column> -->
            <!-- <el-table-column prop="views" label="阅读" align="center"></el-table-column> -->
            <!-- <el-table-column prop="updated_at" label="修改时间" align="center" ></el-table-column> -->
            <el-table-column prop="created_at" label="修改时间" align="center" ></el-table-column>
            <el-table-column label="显示" align="center" width="70">
                <template slot-scope="{row}">
                    <!-- <el-button type="primary" size="small" @click="updateHandle(row)">
                        修改
                    </el-button> -->
                    <el-switch v-model="row.is_show"
                        :active-value="1"
                        :inactive-value="0"
                        @change="IsShowMeetStoryCategory(row)">
                    </el-switch>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="200">
                <template slot-scope="{row}">
                    <el-button type="primary" size="small" @click="updateHandle(row)">
                        修改
                    </el-button>
                    <el-button type="danger" size="small" @click="deleteMeetStoryCategory(row.id)">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
      </el-row>
      <el-row>
        <div class="block">
          <el-pagination background @current-change="getList" :current-page.sync="query.page" :page-size="query.limit" layout="total, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </el-row>
    <el-dialog
      :title="meetStoryCategory.id ? '修改分类' : '添加分类'"
      :visible.sync="dialogVisible"
      :close-on-click-modal='false'
      :close-on-press-escape='false'
      width="50%">
      <el-form :model="meetStoryCategory" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <!-- <el-form-item label="封面图">
          <el-upload
            class="avatar-uploader"
            action="/backend/community/uploadImg"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="meetStoryCategory.img_url" :src="meetStoryCategory.img_url" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item> -->
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="meetStoryCategory.name" maxlength="30" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="分类类型" prop="type">
          <el-select v-model="meetStoryCategory.type" placeholder="请选择分类类型" style="width:33%">
              <el-option
                v-for="item in categoryTypeOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="meetStoryCategory.sort"></el-input>
        </el-form-item>
        <el-form-item label="是否显示">
            <el-switch v-model="meetStoryCategory.is_show"
                :active-value="1"
                :inactive-value="0">
            </el-switch>
          <el-input v-model="meetStoryCategory.is_show"></el-input>
        </el-form-item>
        <!-- <el-form-item label="简介">
          <el-input type="textarea" :autosize="{ minRows: 4, maxRows:15 }" v-model="meetStoryCategory.intro" maxlength="200" show-word-limit></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="阅读数量">
          <el-input v-model="meetStoryCategory.views"></el-input>
        </el-form-item> -->
        <el-form-item>
          <!-- <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button> -->
          <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
            <el-button size="small" @click="dialogVisible = false">取 消</el-button>
            <!-- <el-button size="small" type="primary" @click="create == false ? updateTopic() : createTopic()" :loading="updateLoading">确 定</el-button> -->
            <el-button size="small" type="primary" @click="createUpdateMeetStoryCategory()" :loading="updateLoading">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    </div>
  </template>
  
  <script>
import activityCustomUpload from "@/components/activityCustomUpload.vue";
  import {
    topicList,
    createTopic,
    deleteTopic,
    updateTopic
  } from "@/api/moment";
  import {
    meetStoryCategoryList,
    createUpdateMeetStoryCategory,
    meetStoryCategoryInfo,
    deleteMeetStoryCategory
  } from "@/api/meetStoryCategoryList";
  import { PrefixSource } from 'webpack-sources';
  
  export default {
    data: function() {
      return {
        create: false,
        dialogVisible:false,
        loading: false,
        updateLoading: false,
        list: [],
        total: 0,
        meetStoryCategory: {
            id:null,
            name:'',
            sort: 1,
            is_show:1,
            type:null,
        },
        rules: {
          name: [
            { required: true, message: '请输入分类名称', trigger: 'blur' },
          ]
        },
        query: {
          page: 1,
          limit: 20,
          name: ""
        },
        categoryTypeOptions:[
          {id:1,name:'遇见视频'},
          {id:2,name:'首页视频'},
        ],
      };
    },
    created: function() {
      this.getList();
    },
    methods: {
      tempReset(){
        this.meetStoryCategory =  {
          id:null,
          name:'',
          sort:1,
          is_show:1,
          type:null,
        }
      },
      createInfo(){
        this.create = true
        this.dialogVisible = true
        this.tempReset()
      },
    //   createTopic(){
    //     this.updateLoading = true
    //     createTopic(this.meetStoryCategory).then(response => {
    //       this.updateLoading = false
    //       if(response.status === '2000'){
    //         this.tempReset()
    //         this.$message.success(response.message);
    //         this.getList();
    //         this.dialogVisible = false
    //       }
    //     }).catch(err => {
    //       this.updateLoading = false
    //     });
    //   },
    //   updateTopic(){
    //     this.updateLoading = true
    //     updateTopic(this.meetStoryCategory).then(response => {
    //       this.updateLoading = false
    //       console.log(response)
    //       if(response.status === '2000'){
    //         this.$message.success(response.message);
    //         this.getList();
    //         this.dialogVisible = false
    //       }
    //     });
    //   },
    //   handleAvatarSuccess(res, file) {
    //     if(res.code != 1){
    //       this.$message.error('上传图片失败');
    //     }else{
    //       this.meetStoryCategory.img_url = res.data
    //     }
    //   },
    //   beforeAvatarUpload(file) {
    //     const isLt1M = file.size / 1024 / 1024 < 1;
    //     if (!isLt1M) {
    //       this.$message.error('上传图片大小不能超过 1MB!');
    //     }
    //     return isLt1M;
    //   },
      updateHandle(row){
        this.create = false;
        this.meetStoryCategory = Object.assign({}, row)
        this.dialogVisible = true
      },


      createUpdateMeetStoryCategory(){
        this.updateLoading = true
        let params = {}
        if (this.meetStoryCategory.id) {
          params = {
            id: this.meetStoryCategory.id,
            name: this.meetStoryCategory.name,
            sort: this.meetStoryCategory.sort,
            is_show: this.meetStoryCategory.is_show,
            type: this.meetStoryCategory.type,
          }
        } else {
            params = {
              name: this.meetStoryCategory.name,
              sort: this.meetStoryCategory.sort,
              is_show: this.meetStoryCategory.is_show,
              type: this.meetStoryCategory.type,
            }
        }
        createUpdateMeetStoryCategory(params).then(response => {
          this.updateLoading = false
          console.log(response)
          if(response.status === '2000'){
            this.$message.success(response.message);
            this.getList();
            this.dialogVisible = false
          }
        });
      },
      IsShowMeetStoryCategory(row){
        // this.updateLoading = true
        let params = {
            id: row.id,
            name: row.name,
            sort: row.sort,
            type: row.type,
            is_show: row.is_show == 1 ? 1 : 0,
        }
        createUpdateMeetStoryCategory(params).then(response => {
        //   this.updateLoading = false
        //   console.log(response)
          if(response.status === '2000'){
            this.$message.success(response.message);
            this.getList();
            // this.dialogVisible = false
          }
        });
      },
      deleteMeetStoryCategory(id) {
        this.$confirm("此操作将删除该分类, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          deleteMeetStoryCategory({
            id: id
          }).then(response => {
            if (response.status == 2000) {
              this.getList();
              this.$message({
                showClose: true,
                message: "删除成功",
                type: "success"
              });
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error"
              });
            }
          });
        });
      },
    //   ref() {
    //     window.history.go(0);
    //   },
      getList() {
        this.loading = true;
        meetStoryCategoryList(this.query).then(response => {
          this.list = response.data.list;
          this.total = response.data.total;
          this.loading = false;
        });
      }
    }
  };
  </script>
  <style>
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
  </style>